import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';

import SearchInput from 'components/SearchModal/SearchInput';

import { APIHandler, BackVideo, DataHandler, LanguageSelect, StorageHandler, StoreButtons } from 'C4';
import { bgVideo, storageKeys, rewardsProgramParticipants } from 'settings';

import 'react-toastify/dist/ReactToastify.css';
import Logo from 'assets/images/logo/logo3.png';
import clsx from 'clsx';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '1993-01-10',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
      countryName: '',
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.lang).then((res) => {
      if (res) {
        this.setState({ countryName: res.country });
      }
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    this.addEvent();
    this.registerSalesCompanion();
    this.setAnnouncements();
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  registerSalesCompanion = async () => {
    const user = await StorageHandler.load(storageKeys.user);
    const appId = await DataHandler.matchAppId();

    if (user && user.sales_companion_registered === null) {
      const obj = user;
      const d = new Date(Date.now());
      const leading = (val) => `0${val}`.slice(-2);
      const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;

      const res = await APIHandler.updateUser(appId, obj.email, [{ param: 'sales_companion_registered', val: date }]);

      if (res) {
        obj.sales_companion_registered = date;
        StorageHandler.save(storageKeys.user, obj);
      }
    }
  };

  setAnnouncements = async () => {
    const appId = await DataHandler.matchAppId();
    this.setState({ appId });

    const announcementShownBefore = await StorageHandler.exists(storageKeys.announcement);
    if (!announcementShownBefore) {
      // First check if there is an online announcement registered.
      const res = await APIHandler.getAnnouncement(appId);
      // If there is a response, there is an announcement registered to this appId
      if (res.length !== 0) {
        const ToastContent = () => {
          const { message } = res[0];
          let weburl = '';
          if (res[0] && res[0].weblink) {
            weburl = res[0].weblink;
          }

          let image = '';
          if (res[0] && res[0].img) {
            image = res[0].img;
          }

          return (
            <div>
              <p>
                <a href={weburl} key="toast" target="_blank">
                  <img src={image} />
                  <span dangerouslySetInnerHTML={{ __html: message }} />
                </a>
              </p>
            </div>
          );
        };

        toast.info(ToastContent, {
          position: 'top-center',
          autoClose: false,
          closeOnClick: false,
          transition: Zoom,
          hideProgressBar: true,
          pauseOnHover: true,
          draggable: true,
          toastId: 'announcement',
        });
      }

      // Will check for announcement in i18n based on lang code, but only if there is no API response found. Expects a translation structured as: announcements.{localeCode: e.g. gb}.{message: ..., weblink: ..., img: ...}
      if (res.length === 0) {
        const { code: localeCode } = await StorageHandler.load(storageKeys.lang);
        const hasTranslation = i18n.translate(`announcements.${localeCode}`, { notFound: false }); // returns false if translation is unavailable.
        if (hasTranslation) {
          const weblink = i18n.translate(`announcements.${localeCode}.weblink`, { notFound: '' });
          const img = i18n.translate(`announcements.${localeCode}.img`, { notFound: '' });
          const message = i18n.translate(`announcements.${localeCode}.message`, { notFound: '' });

          const ToastContent = () => {
            return (
              <div>
                <p>
                  <a href={weblink} key="toast" target="_blank">
                    <img src={img} />
                    <span>{message}</span>
                  </a>
                </p>
              </div>
            );
          };

          toast.info(ToastContent, {
            position: 'top-center',
            autoClose: false,
            closeOnClick: false,
            transition: Zoom,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: true,
            toastId: 'announcement',
            onClose: () => StorageHandler.save(storageKeys.announcement, { img, message, weblink }, 604800), // expires in a week
          });
        }
      }
      return null;
    }
  };

  addEvent() {
    // Event snippet for 2022 - US - Campaign Specialist Program - Main Pageview on https://www.canadaspecialistprogram.com/main: Please do not remove.
    if (
      window.location.hostname === 'canadaspecialistprogram.us' ||
      window.location.hostname === 'www.canadaspecialistprogram.us' ||
      window.location.hostname === 'canadaspecialist.us ' ||
      window.location.hostname === 'www.canadaspecialist.us' ||
      window.location.hostname === 'canadaspecialistprogram.com' ||
      window.location.hostname === 'www.canadaspecialistprogram.com' ||
      window.location.hostname === 'canadaspecialist.com' ||
      window.location.hostname === 'www.canadaspecialist.com' ||
      window.location.hostname === 'localhost'
    ) {
      window.gtag('event', 'conversion', {
        allow_custom_scripts: true,
        send_to: 'DC-6628166/csp/2022-00+standard',
        event_category: 'conversion',
        event_label: 'home_page_visit',
      });
    }
  }
  checkForUnreadMessages() {
    DataHandler.requestWithId(APIHandler.getUnreadMessages, this.state.lastCheckedMessages).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  render() {
    const { unreadMessageCount, appId, countryName } = this.state;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    const showRewardsButton = rewardsProgramParticipants
      .map((participant) => participant.toLowerCase())
      .includes(countryName.toLowerCase());

    const getButtonCount = () => {
      let count = 1;

      if (showRewardsButton) count += 1;
      if (appId === 808) count += 2;

      return count;
    };

    return (
      <div className="homeContainer">
        {bgVideo && <BackVideo />}
        <div className="bgHome" />
        <div className="buttonWrapper">
          Download now:
          <StoreButtons />
        </div>
        <LanguageSelect path="home" />
        <Spring from={{ transform: 'translateY(30%)', opacity: 0 }} to={{ transform: 'translateY(0%)', opacity: 1 }}>
          {(props) => (
            <div className="homeView" style={props}>
              <div className="homeView__title">
                <img src={`/${Logo}`} className="homeLogo" alt="logo" />
                <h1>{i18n.translate('homeScreen.title')}</h1>
                <div className="homeView__title--action">
                  <SearchInput />
                  <div
                    className={clsx('homepage__buttons', {
                      'homepage__buttons--1': getButtonCount() === 1,
                      'homepage__buttons--2': getButtonCount() === 2,
                      'homepage__buttons--3': getButtonCount() === 3,
                    })}
                  >
                    <Link to="/main/messages" className="startTrain">
                      {unreadMessageCount === 0 && <p>{i18n.translate('nav.messages')}</p>}
                      {unreadMessageCount > 0 && (
                        <p>
                          {i18n.translate(`${unreadMessageCount === 1 ? 'general.message' : 'general.messagePlural'}`, {
                            count: unreadMessageCount,
                          })}
                        </p>
                      )}
                    </Link>
                    {showRewardsButton && (
                      <Link to="/main/rewards" className="startTrain">
                        <p>
                          <span>{i18n.translate('nav.rewards')}</span>
                        </p>
                      </Link>
                    )}
                    {appId === 808 && (
                      <Link to="/main/sell/contact" className="startTrain">
                        <p>{i18n.translate('general.contact')}</p>
                      </Link>
                    )}
                  </div>
                  {appId === 808 && (
                    <style>
                      {
                        '\
                  .homepage__buttons { grid-template-columns: 1fr 1fr 1fr; grid-gap: 5rem; } .startTrain { width: 16rem; } '
                      }
                    </style>
                  )}
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className="top-bar" />
        <div className="bottom-bar" />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </div>
    );
  }
}
